import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

import "./styles/navbar.css";
import "boxicons";

function NavBar() {
  const [menu, setMenu] = useState(false);
  const menuRef = useRef();

  const handleMenu = async () => {
    await setMenu(!menu);
    menuRef.current.style.display = menu === true ? "none" : "flex";
  };

  console.log(menu);

  return (
    <div>
      <div className="nav-cont">
        <div className="logo">
          <h4>Emily T.</h4>
        </div>

        <div className="link-cont">
          <Link to="/" className="ilink">
            Home
          </Link>
          <Link to="/about" className="ilink">
            About
          </Link>
          <Link to="/resume" className="ilink">
            Resume
          </Link>
          <Link to="/services" className="ilink">
            Skills
          </Link>
          <Link to="/portfolio" className="ilink">
            Portfolio
          </Link>
          <Link to="/contact" className="ilink">
            Contact
          </Link>
        </div>
        {!menu ? (
          <div className="m-menu" onClick={handleMenu}>
            <box-icon name="menu" color="white"></box-icon>
          </div>
        ) : (
          <div className="m-menu" onClick={handleMenu}>
            <box-icon name="x" color="white"></box-icon>
          </div>
        )}

        <div className="m-link-cont" ref={menuRef}>
          <Link to="/" className="mlink">
            Home
          </Link>
          <Link to="/about" className="mlink">
            About
          </Link>
          <Link to="/resume" className="mlink">
            Resume
          </Link>
          <Link to="/services" className="mlink">
            Services
          </Link>
          <Link to="/portfolio" className="mlink">
            Portfolio
          </Link>
          <Link to="/contact" className="mlink">
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NavBar;
